import { render, staticRenderFns } from "./EventGiftManage.vue?vue&type=template&id=87fc37e6&"
import script from "./EventGiftManage.vue?vue&type=script&lang=js&"
export * from "./EventGiftManage.vue?vue&type=script&lang=js&"
import style0 from "./EventGiftManage.vue?vue&type=style&index=0&id=87fc37e6&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87fc37e6')) {
      api.createRecord('87fc37e6', component.options)
    } else {
      api.reload('87fc37e6', component.options)
    }
    module.hot.accept("./EventGiftManage.vue?vue&type=template&id=87fc37e6&", function () {
      api.rerender('87fc37e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/contents/event-gift-manage/EventGiftManage.vue"
export default component.exports